import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { SiteProvider } from './context/SiteContext';
import { I18nProvider } from './i18n';
import './index.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <I18nProvider>
    <SiteProvider>
      <App />
    </SiteProvider>
  </I18nProvider>
);
